export const initialDataPropertiesState = {
  properties: [],
  customProperties: [],
  fixedProperties: [],
  selectedProperties: [],
  sortDirection: 'asc',
  sortKey: 'name',
  searchValue: '',
  onAddCustomProperty: async (property, customProperties) => ({ property, customProperties }),
  onRemoveCustomProperty: async (property, customProperties) => ({ property, customProperties }),
  onAddFixedProperty: async (property, fixedProperties) => ({ property, fixedProperties }),
  onRemoveFixedProperty: async (property, fixedProperties) => ({
    property,
    fixedProperties,
  }),
  onSelectProperty: async (property, selectedProperties) => ({ property, selectedProperties }),
  onRemoveSelectedProperty: async (property, selectedProperties) => ({
    property,
    selectedProperties,
  }),
  onClearSelectedProperties: async () => true,
};

export default (state, action) => {
  switch (action.type) {
    case 'DATA_PROPERTIES_INITIALIZE':
      return { ...state, ...action.state };
    case 'DATA_PROPERTIES_SET_PROPERTIES':
      return { ...state, properties: action.properties };
    case 'DATA_PROPERTIES_SET_CUSTOM_PROPERTIES':
      return { ...state, customProperties: action.customProperties };
    case 'DATA_PROPERTIES_SET_FIXED_PROPERTIES':
      return { ...state, fixedProperties: action.fixedProperties };
    case 'DATA_PROPERTIES_SET_SELECTED_PROPERTIES':
      return { ...state, selectedProperties: action.selectedProperties };
    case 'DATA_PROPERTIES_SET_SORT_DIRECTION':
      return { ...state, sortDirection: action.sortDirection === 'desc' ? 'desc' : 'asc' };
    case 'DATA_PROPERTIES_SET_SORT_KEY':
      return { ...state, sortKey: action.sortKey };
    case 'DATA_PROPERTIES_SET_SEARCH_VALUE':
      return { ...state, searchValue: action.searchValue };
    default:
      return { ...state };
  }
};
